<template>
	<div class="u-position--relative pv ph0 portable-pv-">
		<div class="c-loading-overlay" v-if="resultsLoading"></div>

		<Component
			:is="filterComponent"
			ref="packageFiltersComponent"
			:userAddress="userAddress"
			:targetGroup="targetGroup"
			@newsearchdata="updateResults"
		></Component>

		<div
			class="layout__item u-18/24 u-17/24-desk u-1/1-portable pt portable-ph0 default-pr0 u-position--relative c-comparison-list"
			v-if="!isLoading"
		>
			<div class="u-desk-visuallyhidden portable-mb-" v-if="!isDetailPage">
				<label for="filtersection-mobile" class="c-button c-button--support mb0" @click="showCompareWidget()">
					<h6 class="u-weight--normal">
						Uw gegevens en filters
						<svg width="25" height="21" viewBox="0 0 25 21" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'ml-'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M6.442 2.242H.732a.742.742 0 00-.732.75c0 .414.328.751.733.751h5.709c.325 1.289 1.468 2.242 2.827 2.242s2.502-.953 2.828-2.242h12.17a.743.743 0 00.732-.75.742.742 0 00-.732-.751h-12.17C11.77.952 10.628 0 9.269 0 7.91 0 6.767.952 6.442 2.242zm4.282.75c0 .823-.652 1.491-1.455 1.491s-1.454-.668-1.454-1.49c0-.824.651-1.491 1.454-1.491.803 0 1.455.667 1.455 1.49zm2.179 6.757H.733A.742.742 0 000 10.5c0 .414.329.75.733.75h12.17c.325 1.29 1.468 2.242 2.827 2.242s2.502-.953 2.827-2.241h5.71A.743.743 0 0025 10.5a.742.742 0 00-.733-.75h-5.71c-.325-1.29-1.468-2.242-2.827-2.242-1.36 0-2.502.952-2.827 2.241zm4.282.751c0 .822-.652 1.49-1.455 1.49s-1.455-.668-1.455-1.49c0-.823.652-1.49 1.455-1.49s1.455.667 1.455 1.49zM3.512 17.257H.733a.742.742 0 00-.732.75c0 .415.328.751.732.751h2.779C3.837 20.047 4.98 21 6.339 21c1.36 0 2.502-.953 2.828-2.242h15.1a.743.743 0 00.733-.75.742.742 0 00-.733-.751h-15.1c-.326-1.29-1.469-2.242-2.828-2.242-1.36 0-2.502.953-2.827 2.242zm4.282.75c0 .823-.652 1.491-1.455 1.491s-1.454-.668-1.454-1.49c0-.823.651-1.491 1.454-1.491.803 0 1.455.668 1.455 1.49z" fill="#FFF" fill-rule="evenodd"/></svg>
					</h6>
				</label>
			</div>
			<div class="o-list-base c-comparison-list__results">
				<powered-by :is-full="true"></powered-by>

				<package-result-item
					v-for="(item, index) in ResultItems"
					:key="item.SerialId + 'packageResultItem' + index"
					:user-input="lastUserInput"
					:result-item="item"
					v-on:show-overview="showOverview"
				></package-result-item>
				<current-supplier-message
					v-if="currentSupplierMessage.show && !isDetailPage && !resultsLoading"
					:current-supplier-message="currentSupplierMessage"
				></current-supplier-message>
				<template v-if="resultsLoading">
					<div
						v-for="i in Blueprints"
						:key="i"
						class="c-comparison-list__item mb- desk-wide-mb c-comparison-list__item--blueprint"
					></div>
				</template>

				<div
					class="u-text-align--center"
					v-if="!isDetailPage && !resultsLoading && ResultItems && ResultItems.length > 0 && hasMoreResults"
				>
					<button @click="getMoreResults()" class="c-button c-button--big c-button--support">
						Toon nog {{ PageSize }} resultaten
					</button>
				</div>
				<div class="u-text-align--center" v-if="!hasMoreResults && ResultItems.length > 0 && !isDetailPage">
					<button class="c-button c-button--big c-button--support c-button--disabled">
						Geen resultaten meer
					</button>
				</div>
				<div
					v-if="ResultItems && ResultItems.length === 0"
					class="u-bg-color-white zeta u-text-align--center pv+ ph mb"
				>
					<h6 class="mb">Met uw huidige filters kunnen we geen resultaten vinden.</h6>
					<div>
						Pas uw filters aan in de linkerkolom of klik op reset alle filters om alle filters weg te halen.
					</div>
					<a
						class="c-gl-compare-widget__reset mt u-weight--bold u-cursor--pointer"
						@click="clearFilters()"
						v-tooltip="'Reset alle filters'"
						>Begin opnieuw met vergelijken</a
					>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Api from '@/services/api.energy';
import PackageResultItem from '@/energy/partials/PackageResultItem';
import CurrentSupplierMessage from '@/energy/partials/CurrentSupplierMessage';
import PackageFiltersConsumer from '@/energy/partials/packagefilters/PackageFiltersConsumer.vue';
import PackageFiltersBusiness from '@/energy/partials/packagefilters/PackageFiltersBusiness.vue';
import PoweredBy from '@/energy/partials/PoweredBy';
import { eventHub } from '@/services/eventhub';

export default {
	props: {
		targetGroup: {
			type: String,
			default: null,
		},
	},
	components: {
		PackageFiltersConsumer,
		PackageFiltersBusiness,
		PackageResultItem,
		PoweredBy,
		CurrentSupplierMessage,
	},
	data() {
		return {
			// eslint-disable-next-line
			PageSize: APP_PAGESIZE,
			fromDirect: false,
			firstLoad: true,
			isLoading: false,
			resultsLoading: false,
			currentSupplierMessage: { show: false },
			userAddress: {},
			isInitializing: true,
			currentCall: null,
			hasMoreResults: true,
			Blueprints: [],
			lastUserInput: [],
			ResultItems: null,
			metaData: null,
			SavedResultItems: null,
			lastScrollPosition: -1,
		};
	},
	methods: {
		showCompareWidget() {
			if (this.$refs.packageFiltersComponent) {
				this.$refs.packageFiltersComponent.toggleOpened();
			}
			if (this.$refs.packageFiltersBusinessComponent) {
				this.$refs.packageFiltersBusinessComponent.toggleOpened();
			}
		},
		clearFilters() {
			if (this.$refs.packageFiltersComponent) {
				this.$refs.packageFiltersComponent.resetFormData();
			}
			if (this.$refs.packageFiltersBusinessComponent) {
				this.$refs.packageFiltersBusinessComponent.resetFormData();
			}
		},
		async updateResults(data) {
			if (data && data.doneInitializing) {
				this.isInitializing = false;
			}
			if (
				this.isInitializing ||
				(!this.$refs.packageFiltersBusinessComponent && !this.$refs.packageFiltersComponent)
			) {
				return;
			}
			this.resultsLoading = true;
			this.userData = this.$refs.packageFiltersComponent.userData;
			this.currentSupplierMessage.show = false;
			if (this.currentCall) {
				clearTimeout(this.currentCall);
			}
			this.resultsLoading = true;
			this.ResultItems = [];

			this.userData.Skip = 0;
			this.userData.resultsOnly = true;

			this.currentCall = setTimeout(async () => {
				await this.loadData();
				this.doOriginCheck();
			}, 12);
		},
		async getMoreResults() {
			if (this.currentCall) {
				clearTimeout(this.currentCall);
			}
			this.resultsLoading = true;
			this.currentCall = setTimeout(async () => {
				this.userData.Skip += this.userData.Take;
				this.track('Show more results', 'page', parseInt(this.userData.Skip / 10) + '');
				this.userData.resultsOnly = true;
				this.loadData();
			}, 500);
		},
		async loadData() {
			let ignoredKeys = [
				'Skip',
				'Page',
				'Postalcode',
				'PackageType',
				'HouseNumber',
				'HouseNumberAddition',
				'HighElectricityConsumption',
				'LowElectricityConsumption',
				'HighElectricityDeliveredBack',
				'LowElectricityDeliveredBack',
				'GasConsumption',
				'SortFilter',
				'CostDisplayFilter',
			];
			let explicitIncludedKeys = ['co2compensated'];
			Object.keys(this.userData).forEach((k) => {
				if (k.substring(0, 1) !== k.substring(0, 1).toLowerCase() || explicitIncludedKeys.indexOf(k) > -1) {
					if (this.userData[k] !== null && this.userData[k] !== '' && ignoredKeys.indexOf(k) === -1) {
						let value = this.userData[k];
						if (k === 'Take') {
							// eslint-disable-next-line
							value = parseInt(value) / APP_PAGESIZE;
							k = 'Page';
						}
						let trackingParameters = ['Searching', k, value];
						this.track(...trackingParameters);
					}
				}
			});
			this.userData.targetGroup = this.targetGroup;

			let results = await Api.getResults(this.userData);
			if (this.userData.Skip === 0) {
				if (
					typeof results.Results.CurrentSupplierName !== 'undefined' &&
					(!results.Results.CurrentSupplierInResults || !results.Results.CurrentSupplierInTop10)
				) {
					let message = '';
					if (!results.Results.CurrentSupplierInTop10 && results.Results.CurrentSupplierInResults) {
						message = `staat helaas niet in de top 10. <br /> De tariefsvoorwaarden (actietarieven en/of welkomstpremie) van beschikbare pakketten voor bestaande klanten zijn minder scherp dan die van de pakketten hierboven.`;
					} else {
						message = `komt niet voor in de resultaten. <br /> De leverancier biedt momenteel geen passend aanbod dat overeenkomt met uw opgegeven energievoorkeuren.`;
					}
					this.currentSupplierMessage = {
						show: true,
						message: message,
						supplierName: results.Results.CurrentSupplierName,
						supplierLogo: results.Results.CurrentSupplierLogo,
					};
				}
			}
			this.ResultItems.push(...results.Results.Packages);
			this.metaData = results.MetaData;
			Api.saveMetaData(results.MetaData);
			if (results.Results.AddressInfo) {
				this.userAddress = results.Results.AddressInfo;
			}
			this.lastUserInput = results.Input ? results.Input : null;

			this.hasMoreResults = !results.Results.LastPage;
			if (this.$router) {
				this.$router.push({ name: 'comparison' });
			}
			this.resultsLoading = false;
			return;
		},

		getAnchorName() {
			return `package-details-${this.getSerialIdFromUrl()}`;
		},
		getAnchorNameFromOldRoute() {
			return `package-details-${this.getSerialIdFromUrl({
				fromOldRoute: true,
			})}`;
		},
		async showOverview() {
			if (this.fromDirect) {
				this.ResultItems = [];
				this.SavedResultItems = [];
				this.fromDirect = false;
				this.$forceUpdate();
				this.updateResults();
			} else {
				this.ResultItems = this.SavedResultItems;
				setTimeout(() => {
					window.scrollTo(0, this.lastScrollPosition);
				}, 400);
			}
		},
		async doOriginCheck() {
			let storageKey = 'comparisonConfig';
			let originData = this.storageGetObject(storageKey);
			let workData = originData;

			if (!workData) {
				return;
			}
			let itemFromResults = this.ResultItems.find((rI) => rI.SerialId === workData.packageId);
			let selectedItem;
			if (itemFromResults) {
				selectedItem = itemFromResults;
			} else {
				selectedItem = await Api.getPackageDetails(workData.packageId);
			}

			this.ResultItems = [selectedItem];
			this.storageRemoveObject(storageKey);
			this.fromDirect = true;
			if (workData.page === 'detailPage') {
				eventHub.$emit('changed-detail', workData);
			} else {
				eventHub.$emit('show-form', selectedItem);
			}
		},
	},
	async mounted() {
		//set the number of placeholders according  tot the pagesize ("Take")
		for (let i = 0; i < 10; i++) {
			this.Blueprints[i] = i;
		}

		this.isInitializing = true;
		if (this.isDetailPage) {
			setTimeout(() => {
				this.isInitializing = false;
			}, 300);
		}

		eventHub.$on('hide-form', () => {
			setTimeout(() => {
				this.updateResults();
			}, 100);
		});

		eventHub.$on('changed-detail', async (params) => {
			const isDetail = params.packageId !== null;
			if (isDetail) {
				if (document.getElementById('package-details-' + params.packageId)) {
					this.lastScrollPosition = document.getElementById('package-details-' + params.packageId).offsetTop;
				}

				this.SavedResultItems = this.ResultItems;
			} else {
				this.ResultItems = this.SavedResultItems;

				this.SavedResultItems = null;
			}
		});
	},
	computed: {
		filterComponent() {
			let component = this.targetGroup === 'Consumer' ? 'PackageFiltersConsumer' : 'PackageFiltersBusiness';
			return component;
		},
	},
};
</script>
